var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Train") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    d: "M15 1.5a1.5 1.5 0 0 1 3 0v53a1.5 1.5 0 0 1-3 0v-53zM37 47v3H19v-3h18zm5 0h2.5a1.5 1.5 0 0 1 0 3H42v-3zm-5-10v3H19v-3h18zm5 0h2.5a1.5 1.5 0 0 1 0 3H42v-3zm-5-10v3H19v-3h18zm5 0h2.5a1.5 1.5 0 0 1 0 3H42v-3zm-5-10v3H19v-3h18zm5 0h2.5a1.5 1.5 0 0 1 0 3H42v-3zM37 7v3H19V7h18zm5 0h2.5a1.5 1.5 0 0 1 0 3H42V7zM14 47v3h-2.5a1.5 1.5 0 0 1 0-3H14zm0-10v3h-2.5a1.5 1.5 0 0 1 0-3H14zm0-10v3h-2.5a1.5 1.5 0 0 1 0-3H14zm0-10v3h-2.5a1.5 1.5 0 0 1 0-3H14zm0-10v3h-2.5a1.5 1.5 0 0 1 0-3H14zm24-5.5a1.5 1.5 0 0 1 3 0v53a1.5 1.5 0 0 1-3 0v-53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h56v56H0z",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/Train.ce4270a3254cd34bbf2493ca7df17be8.svg";
export { ForwardRef as ReactComponent };